import React from 'react'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components'
import { SidebarItem } from './SidebarItem'
import addpath from '../data/addpath'
import useAuth from '../features/hooks/useAuth'
import filtereddata from '../data/filterUI';

const SidebarContainer = styled.div`
  width:${({ sideBarOpen }) => sideBarOpen? "270 px":""};
  width: 70px;
  /* height: 200vh; */
   /* calc(100vh - 60px); */
  transition: width 1s;
  :hover {
  width: 270px;
}
  background-image: linear-gradient(to bottom, #a961f1, #57ccf4);
  /* background-color:  #a961f1; */
  border-radius: 10px;
  box-shadow: none;
  overflow-y:auto;
  display: flex;
  flex-direction: column;
  z-index: 1200;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  box-sizing: border-box;
  overflow-x: hidden;
  padding: 10px;
`

export const Sidebar = () => {
  const [sideBarOpen, setSideBarOpen] = useState(false);

  const Auth = useAuth();
  const currentOffice = useSelector((state) => state.office.off)

  const handleOnMouseOver = () =>{
    setSideBarOpen(true)
  }

  const handleOnMouseOut = () =>{
    setSideBarOpen(false)
  }  

  const finaldata = addpath(filtereddata(Auth, currentOffice));

  return (
    <SidebarContainer sideBarOpen={sideBarOpen} onMouseOver={handleOnMouseOver} onMouseOut={handleOnMouseOut} >
      <div>
      {finaldata.map((item, index) => <SidebarItem sideBarOpen={sideBarOpen} key={index} item={item}  />)}
      </div>
    </SidebarContainer>


  )
}
